import { render, staticRenderFns } from "./department.vue?vue&type=template&id=d95a5cd6&scoped=true"
import script from "./department.vue?vue&type=script&lang=js"
export * from "./department.vue?vue&type=script&lang=js"
import style0 from "./department.vue?vue&type=style&index=0&id=d95a5cd6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d95a5cd6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d95a5cd6')) {
      api.createRecord('d95a5cd6', component.options)
    } else {
      api.reload('d95a5cd6', component.options)
    }
    module.hot.accept("./department.vue?vue&type=template&id=d95a5cd6&scoped=true", function () {
      api.rerender('d95a5cd6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/assessment/department.vue"
export default component.exports